// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* 팝업 딤: 딤 위 휠 스크롤이 배경 페이지로 전파되지 않도록 차단 (기존 body overflow 잠금의 CSS 대체) */\n.popup_dim[data-v-244baad4] {\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n", ""]);
// Exports
module.exports = exports;
